<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="accent-100">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="titulo">{{'SHEDULE.SELECT_DATE' | translate}}</span>
            <button mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="onNoClick()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>

        <form>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'SHEDULE.SELECT_DATE' | translate}}</mat-label>
                    <input matInput [matDatepicker]="birthdayDatePicker" [matDatepickerFilter]="data.filtroFechas" name="birthday" [(ngModel)]="data.animal">
                    <mat-datepicker-toggle matSuffix [for]="birthdayDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthdayDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div fxLayout="row" class="textarea-wrapper" fxLayoutAlign="start start" disabled>
                <div class="p-16 pt-4">
                </div>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button mat-button class="save-button" [mat-dialog-close]="data.animal" aria-label="SAVE">
            {{'SHEDULE.SAVE' | translate}}
        </button>

    </div>
</div>
